import { GetOrganizationDto } from '../dtos/getOrganizationDto.interface';

export interface IUpdateOrganizationDialogData {
    organization: GetOrganizationDto;
    action: any;
    isExcel?: boolean; // Optional property to indicate if this is for Excel template upload
}
